export function dealFileSize(size) {
	let num = Number(size) || 0
	let unit = ''
	if (num < 1024) {
		unit = 'B'
	} else if (num < 1024 * 1024) {
		num = (num / 1024)
		unit = 'KB'
	} else if (num < 1024 * 1024 * 1024) {
		num = (num / (1024 * 1024))
		unit = 'MB'
	} else {
		num = (num / (1024 * 1024 * 1024))
		unit = 'GB'
	}
	return num.toFixed(1) + unit
}